import React from 'react';
import { trans } from '@spotahome/soyuz/client';
import { Autocompleter as AutocompleterComponent } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Autocompleter/Autocompleter.css';

import { MIN_LENGTH_AUTOCOMPLETER } from '../common/constants';

const Autocompleter = ({
  cityNames,
  initialValue,
  onSelectedElement,
  onNoResults
}) => (
  <AutocompleterComponent
    list={cityNames}
    minLength={MIN_LENGTH_AUTOCOMPLETER}
    initialValue={initialValue}
    placeholder={trans('landingpage.city_selector.select_city')}
    onSelectedElement={onSelectedElement}
    onNoResults={onNoResults}
  />
);

Autocompleter.propTypes = {
  cityNames: AutocompleterComponent.propTypes.list.isRequired,
  initialValue: AutocompleterComponent.propTypes.initialValue.isRequired,
  onNoResults: AutocompleterComponent.propTypes.onNoResults.isRequired,
  onSelectedElement:
    AutocompleterComponent.propTypes.onSelectedElement.isRequired
};

export default Autocompleter;
